import { createReducer, createSelector, on } from '@ngrx/store';
import { PageProcessEventLogEntryDTO } from '@iota/inh-core-v1-management-client';
import { LoadProcessEventLogs, LoadProcessEventLogsFailure, LoadProcessEventLogsSuccess } from '../actions/process-event-log.actions';
import { AppState } from '../store';

export interface ProcessEventLogState {
    page: PageProcessEventLogEntryDTO | undefined;
    loading: boolean;
    error: any;
}

export const initialState: ProcessEventLogState = {
    page: undefined,
    loading: false,
    error: undefined
};

export const processEventLogReducer = createReducer(
    initialState,

    on(LoadProcessEventLogs, (state) => ({ ...state, loading: true })),
    on(LoadProcessEventLogsSuccess, (state, { page }) => ({ ...state, page, loading: false, error: undefined })),
    on(LoadProcessEventLogsFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const processEventLogState = (state: AppState) => state.processEventLogState;
export const processEventLogPage = createSelector(processEventLogState, (state) => state.page);
export const processEventLogEntries = createSelector(processEventLogPage, (page) => page?.content ?? []);
export const processEventLogTotalElements = createSelector(processEventLogPage, (page) => page?.totalElements ?? 0);
export const processEventLogsLoading = createSelector(processEventLogState, (state) => state.loading);
export const processEventLogsError = createSelector(processEventLogState, (state) => state.error);
